import { PropsWithChildren } from 'react';
import styles from '../Footer.module.scss';
import { CatGrid } from '@blocks-react/components/Grid';

export const FooterLinksContainer = ({ children }: PropsWithChildren) => (
  <CatGrid variant="4up">
    <div
      className={`${styles['footer-links__container']}`}
      data-testid="footerLinksContainerTestId"
    >
      {children}
    </div>
  </CatGrid>
);
